
<div class="relative flex flex-col h-full min-h-0 bg-white overflow-y-auto md:overflow-hidden" [@rise]>
  <div class="relative flex-1 min-h-0 w-full h-full">
  @if (stage() === 'renew') {
    <div class="relative flex flex-col md:flex-row w-full h-full min-h-0">
    <button type="button"
            class="md:hidden absolute top-[14px] right-[14px] z-10 size-8 rounded-full bg-white/[0.16] border-none text-white text-[14px] font-semibold cursor-pointer flex items-center justify-center hover:bg-white/[0.26]"
            (click)="close()" aria-label="Close"><span>✕</span></button>

    <aside class="shrink-0 w-full md:w-[320px] h-auto md:h-full bg-[#0f3d3b] px-5 py-[22px] md:pt-8 md:pb-7 md:px-7 flex flex-col gap-3 md:gap-[14px]">
      @if (expiredDatePlan()) {
        <span class="self-start inline-flex items-center gap-[6px] bg-[#FFEBEB] text-[#D92E2E] text-[10px] font-bold tracking-[0.4px] py-[3px] pl-2 pr-[10px] rounded-[100px]">
          <span class="size-[6px] rounded-full bg-[#D92E2E]"></span>
          <span>EXPIRED </span>
        </span>
      } @else {
        <span class="self-start inline-flex items-center gap-[6px] bg-[#ffedd1] text-[#99470d] text-[10px] font-bold tracking-[0.4px] py-[3px] pl-2 pr-[10px] rounded-[100px]">
          <span class="size-[6px] rounded-full bg-[#99470d]"></span>
          <span>EXPIRES IN {{ daysLeft() }} {{ daysLeft() === 1 ? 'DAY' : 'DAYS' }}</span>
        </span>
      }

      <h2 class="m-0 text-white text-[20px] md:text-[22px] font-bold leading-[1.15]">Renew your {{ activatedPlan()?.userPlanType | titlecase }} plan</h2>
      <p class="m-0 text-[#a1c4c7] text-[12px] leading-[1.5]">Keep your locked rates, compliance hours and dedicated support without interruption.</p>

      <div class="bg-white/[0.06] border border-white/[0.12] rounded-[10px] px-[14px] py-3 flex flex-col gap-2 w-full">
        <div class="flex flex-col gap-1 w-full">
          <div class="flex items-center justify-between text-[11px]">
            <span class="text-[#a1c4c7] font-medium">Balance used</span>
            <span class="text-white font-semibold">{{ (activatedPlan()?.balanceUsed ?? 0) | number:'1.2-2' }} USDT / {{ activatedPlan()?.planPrice | number:'1.2-2' }} USDT</span>
          </div>
          <div class="h-1 w-full bg-white/10 rounded-full overflow-hidden">
            <div class="h-full bg-[#66e5b2] rounded-full transition-[width] duration-500" [style.width.%]="balanceProgress()"></div>
          </div>
        </div>
        @if (activatedPlan()?.complianceHoursUsed) {
          <div class="flex flex-col gap-1 w-full">
            <div class="flex items-center justify-between text-[11px]">
              <span class="text-[#a1c4c7] font-medium">Compliance support</span>
              <span class="text-white font-semibold">{{ activatedPlan()?.complianceHoursUsed }}h / {{ activatedPlan()?.complianceHoursGranted }}h</span>
            </div>
            <div class="h-1 w-full bg-white/10 rounded-full overflow-hidden">
              <div class="h-full bg-[#f0b52e] rounded-full transition-[width] duration-500" [style.width.%]="complianceProgress()"></div>
            </div>
          </div>
        }
      </div>
    </aside>

    <section class="flex-1 h-auto md:h-full bg-white p-5 md:px-7 md:py-6 flex flex-col gap-3 min-w-0">
      <header class="flex items-center justify-between">
        <div class="flex flex-col gap-[2px]">
          <p class="m-0 text-[#022d35] text-[16px] font-semibold">Renewal options</p>
          <p class="m-0 text-[#6b7d82] text-[11px]">Continue {{ activatedPlan()?.name }} or switch tier on renewal</p>
        </div>
        <button type="button"
                class="hidden md:flex size-7 rounded-full bg-[#f5f7f7] border-none cursor-pointer items-center justify-center text-[#6b7d82] text-[16px] font-bold transition-colors hover:bg-[#e8ebeb] hover:text-[#022d35]"
                (click)="close()" aria-label="Close">×</button>
      </header>

      <button type="button" class="flex items-center gap-[10px] py-[11px] px-[13px] w-full border-2 border-[#218c59] bg-[#e5f5ed] rounded-[12px] text-left transition-all">
        <span class="shrink-0 size-[18px] rounded-full bg-white border-2 border-[#218c59] flex items-center justify-center">
          <span class="size-[8px] rounded-full bg-[#218c59]"></span>
        </span>
        <div class="flex-1 flex flex-col gap-[2px] min-w-0">
          <div class="flex items-center gap-[6px] flex-wrap">
            <span class="text-[#022d35] text-[14px] font-semibold">{{ activatedPlan()?.userPlanType | titlecase }} ·
              @switch (activatedPlan()?.billingCycle) {
                @case ('MONTHLY') {
                  Monthly
                }
                @case ('YEARLY') {
                  Annual
                }
              }
              (same)</span>
            <span class="bg-[#218c59] text-white text-[8px] font-bold tracking-[0.32px] px-[6px] py-[1px] rounded-full">RECOMMENDED</span>
          </div>
          <p class="m-0 text-[#6b7d82] text-[11px]">Same rates, same balance,
            @switch (activatedPlan()?.billingCycle) {
              @case ('MONTHLY') {
                1
              }
              @case ('YEARLY') {
                12
              }
            }
            mo lock</p>
        </div>
        <span class="text-[#022d35] text-[13px] font-semibold shrink-0">
          @switch (activatedPlan()?.billingCycle) {
            @case ('MONTHLY') {
              {{ actualPlanForTemplate()?.planPriceMonthly }} <span class="text-[#022d35] text-[11px] font-semibold">USDT</span>/mo
            }
            @case ('YEARLY') {
              {{ actualPlanForTemplate()?.planPriceYearly }} <span class="text-[#022d35] text-[11px] font-semibold">USDT</span>/yr
            }
          }</span>
      </button>

      <button (click)="redirectToPricing()" type="button" class="flex items-center gap-[10px] py-3 px-[14px] w-full border border-[#dee3e3] rounded-[12px] bg-white text-left transition-all hover:border-[#022d35]">
        <span class="shrink-0 size-[18px] rounded-full bg-white border-2 border-[#b8c2c4] flex items-center justify-center">
          <span class="size-[8px] rounded-full bg-transparent"></span>
        </span>
        <div class="flex-1 flex flex-col gap-[2px] min-w-0">
          <span class="text-[#022d35] text-[14px] font-semibold">Switch tier on renewal</span>
          <p class="m-0 text-[#6b7d82] text-[11px]">
            @switch (activatedPlan()?.userPlanType) {
              @case ('PRO') {
                Move to
                @if (corporateAnnualPrice() > 0) {
                  Corporate ({{ corporateAnnualPrice() }}) or
                }
                Enterprise (custom)
              }
              @case ('CORPORATE') {
                Move to Enterprise (custom)
              }
            }
          </p>
        </div>
        <span class="text-[#022d35] text-[13px] font-semibold shrink-0">Compare →</span>
      </button>

      <div class="flex gap-2 bg-[#fff5d9] px-3 py-[10px] rounded-lg text-[#996b0d]">
        <span class="text-[12px] font-bold shrink-0">⚠</span>
        <p class="m-0 text-[11px] leading-[1.45]">
          @let balanceNotUsed = (activatedPlan()?.planPrice ?? 0) - (activatedPlan()?.balanceUsed ?? 0);
          If you don't renew, after {{ activatedPlan()?.expirationDate | date:'d MMM yyyy' }}: rates revert to 2 USDT/report base, {{ balanceNotUsed | number:'1.2-2' }} USDT unused balance forfeits, compliance hours reset.
        </p>
      </div>

      <div class="hidden md:block flex-1 min-h-0"></div>

      <button type="button"
              class="group flex items-center justify-center gap-[6px] w-full h-11 md:h-11 bg-[#022d35] text-white text-[14px] font-semibold rounded-[10px] cursor-pointer transition-all border-none hover:bg-[#1a8c99] hover:shadow-[0_6px_16px_0_rgba(23,115,125,0.45)] active:scale-[0.98]"
              (click)="renew()">
        Renew {{ activatedPlan()?.userPlanType | titlecase }} ·
        @switch (activatedPlan()?.billingCycle) {
          @case ('MONTHLY') {
            {{ actualPlanForTemplate()?.planPriceMonthly }} USDT/mo
          }
          @case ('YEARLY') {
            {{ actualPlanForTemplate()?.planPriceYearly }} USDT/yr
          }
        }
        <span class="transition-transform group-hover:translate-x-[3px]">→</span>
      </button>
      @if (data && data.showHideBanner) {
        <button type="button" class="bg-transparent border-none text-[#6b7d82] text-[11px] font-medium cursor-pointer text-center p-1 w-full hover:text-[#022d35]" (click)="dontShowAgain()">Don't show again until day before</button>
      }
    </section>
    </div>
  } @else {
    @if (invoiceUuid(); as invoiceUuid) {
      <app-invoice-plan-upgrade (outputInvoiceStatus)="invoiceStatus.set($event)" [invoiceUuid]="invoiceUuid"></app-invoice-plan-upgrade>
    }
  }
  </div>
</div>
